<script>
import { Helper } from '@/mixin/helper'

export default {
  name: 'NotificationModal',

  mixins: [Helper],

  props: {
    notifications: {
      type: Array,
      required: true,
    },
  },

  created() {
    const userId = this.getUserId()
    this.$store.dispatch('notification/fetchUnreadCount', userId)
  },

  methods: {
    handleNotificationClick(notification) {
      if (!notification.wo_number) return

      if (!notification.is_read) {
        this.$store.dispatch(
          'notification/markNotificationRead',
          notification.notification_id
        )
      }

      const isTechnician = Number(this.$store?.state?.users?.user?.position_id) ===
        Number(process.env.VUE_APP_TECHNICIAN_POSITION_ID)

      // 🔥 Tutup modal
      this.$emit('close')

      if (isTechnician) return

      if (this.$route.path === `/work-order/validation/form/${notification.wo_number}`) {
        window.location.reload()
      } else {
        this.$router.push({
          path: '/work-order/validation/form/' + notification.wo_number,
        })
      }
    }

  },
}
</script>

<template>
  <div class="mc-notification__modal">
    <div class="mc-notification__header">
      <h5 class="mc-notification__title">Notifications</h5>
      <div class="mc-notification__actions">
        <b-button variant="link" size="sm" class="mc-notification__btn-mark-read" @click.stop="$emit('mark-all-read')">
          <i class="bx bx-check"></i>
          Mark all read
        </b-button>
        <router-link :to="{ name: 'Notification Settings' }" custom v-slot="{ navigate }">
          <b-button variant="link" size="sm" class="mc-notification__btn-settings" @click.stop="navigate">
            <i class="bx bx-cog"></i>
          </b-button>
        </router-link>
      </div>
    </div>

    <div class="mc-notification__list">
      <div v-for="notification in notifications" :key="notification.notification_id" class="mc-notification__item"
        :class="{ 'mc-notification__item--unread': !notification.is_read }"
        @click="handleNotificationClick(notification)">
        <div class="mc-notification__indicator" v-if="!notification.is_read"></div>
        <div class="mc-notification__content">
          <h6 class="mc-notification__item-title">{{ notification.name }}</h6>
          <p class="mc-notification__item-message">{{ notification.description }}</p>
          <div class="mc-notification__item-meta">
            <span class="mc-notification__user">{{ notification.username }}</span>
            <span class="mc-notification__time">
              <i class="bx bx-time-five"></i>
              {{ getRelativeTime(notification.created_at) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="mc-notification__footer">
      <b-button variant="link" class="mc-notification__btn-view-all"
        @click.stop="$router.push({ name: 'All Notifications' })">
        View all notifications
      </b-button>
    </div>
  </div>
</template>
